export default class QueryParameterError extends Error {
    isQueryParameterError = true;
}
export function isQueryParameterError(e) {
    return typeof e === 'object' && e !== null && e.isQueryParameterError === true;
}
